// extracted by mini-css-extract-plugin
export default {"links":"classes_links__WA-5W"};